export default __webpack_public_path__ + "static/media/landing-swimming.d5ad1817.jpg";